/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MatchLobbyMemberResponse
 */
export interface MatchLobbyMemberResponse {
    /**
     * 
     * @type {string}
     * @memberof MatchLobbyMemberResponse
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof MatchLobbyMemberResponse
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof MatchLobbyMemberResponse
     */
    playerName?: string;
    /**
     * 
     * @type {string}
     * @memberof MatchLobbyMemberResponse
     */
    avatarUrl?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MatchLobbyMemberResponse
     */
    isCaptain: boolean;
    /**
     * Whether this member has a telemetry co-presence report for the match (in the lobby).
     * @type {boolean}
     * @memberof MatchLobbyMemberResponse
     */
    present: boolean;
}

/**
 * Check if a given object implements the MatchLobbyMemberResponse interface.
 */
export function instanceOfMatchLobbyMemberResponse(value: object): value is MatchLobbyMemberResponse {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('isCaptain' in value) || value['isCaptain'] === undefined) return false;
    if (!('present' in value) || value['present'] === undefined) return false;
    return true;
}

export function MatchLobbyMemberResponseFromJSON(json: any): MatchLobbyMemberResponse {
    return MatchLobbyMemberResponseFromJSONTyped(json, false);
}

export function MatchLobbyMemberResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchLobbyMemberResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'displayName': json['displayName'],
        'playerName': json['playerName'] == null ? undefined : json['playerName'],
        'avatarUrl': json['avatarUrl'] == null ? undefined : json['avatarUrl'],
        'isCaptain': json['isCaptain'],
        'present': json['present'],
    };
}

export function MatchLobbyMemberResponseToJSON(json: any): MatchLobbyMemberResponse {
    return MatchLobbyMemberResponseToJSONTyped(json, false);
}

export function MatchLobbyMemberResponseToJSONTyped(value?: MatchLobbyMemberResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'displayName': value['displayName'],
        'playerName': value['playerName'],
        'avatarUrl': value['avatarUrl'],
        'isCaptain': value['isCaptain'],
        'present': value['present'],
    };
}

